import { IPaginationParam, IPaginationResult } from '../../lib/ajax-helper';
import { useQuery, UseQueryOptions } from 'react-query';
import { getUserBadges } from '../../services/api-badges.service';
import { IUserBadge, UserBadgeStatus } from '../../shared/interfaces/badges.interface';

export const queryKeys = {
  indexBadges: 'indexBadges',
};

export const useIndexBadges = (
  userId: string,
  status: UserBadgeStatus,
  pagination: IPaginationParam,
  options?: UseQueryOptions<IPaginationResult<IUserBadge>>
) => {
  return useQuery(
    [queryKeys.indexBadges, pagination],
    () => getUserBadges(userId, status, pagination),
    options
  );
};